import PropTypes from "prop-types";

import contentPreviewSettings from "@/view/constants/contentPreviewSettings/contentPreviewSettings.constants";
import NewselaLogo from "@/view/NewselaLogo";
import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";
import Banner from "../Banner";
import BannerHeaderText from "../Banner/BannerHeaderText";
import {
  previewModeBodyCss,
  previewModeLogoCss,
  previewModeActionButtonCss,
} from "./PreviewModeBanner.style";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  handleToggleBannerMode: PropTypes.func,
  bannerRef: PropTypes.object,
  previewFor: PropTypes.string,
};

const PreviewModeBanner = ({
  contentId,
  contentType,
  handleToggleBannerMode,
  bannerRef,
  previewFor,
}) => {
  const handleClose = () => window.close();
  const logo = <NewselaLogo />;
  const bannerAriaLabel = "Preview mode";
  const closeButtonAriaLabel = "Close window";
  const bannerTitle =
    previewFor &&
    contentPreviewSettings.supportedValues[previewFor].headerContents;

  const eventProperties = {
    objectType: "Content",
    actionName: "Read",
    streamProperties: {
      content_type: getEventPropertiesContentType(contentType),
      description: "Close window",
      content_id: contentId,
    },
  };

  const __cssFor = {
    logoCss: previewModeLogoCss,
    bodyCss: previewModeBodyCss,
    actionButtonCss: previewModeActionButtonCss,
  };

  return (
    <Banner
      __cssFor={__cssFor}
      bannerAriaLabel={bannerAriaLabel}
      bannerRef={bannerRef}
      closeButtonAriaLabel={closeButtonAriaLabel}
      contentId={contentId}
      contentType={contentType}
      eventProperties={eventProperties}
      handleToggleBannerMode={handleToggleBannerMode}
      logo={logo}
      onClose={handleClose}
    >
      <BannerHeaderText title={bannerTitle} />
    </Banner>
  );
};

PreviewModeBanner.propTypes = propTypes;

export default PreviewModeBanner;
